module.exports = __webpack_public_path__ + "img/logo.a5cf4571.png";